function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var openSansFont = "'Open Sans', HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export var letterSpacings = {
  tighter: '-0.05em',
  tight: '-0.013em',
  normal: '0',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em'
};
var lineHeights = {
  normal: 'normal',
  none: 1,
  short: '1.25rem',
  button: '1.375rem',
  base: '1.5rem',
  tall: '2.5rem',
  taller: '3.5rem'
};
export var fontWeights = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};
var fonts = {
  heading: openSansFont,
  body: openSansFont,
  mono: "SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace"
};
var fontSizes = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem ',
  mdlg: '1.5rem ',
  lg: '1.25rem',
  xl: '1.875rem',
  '2xl': '3rem'
};
export var headingSizes = {
  xl: {
    fontSize: '2xl',
    lineHeight: 'taller'
  },
  lg: {
    fontSize: 'xl',
    lineHeight: 'tall'
  },
  mdlg: {
    fontSize: 'mdlg',
    lineHeight: 'base'
  },
  md: {
    fontSize: 'lg',
    lineHeight: 'base'
  },
  sm: {
    fontSize: 'md',
    lineHeight: 'base'
  }
};
export var textSizes = {
  lg: {
    fontSize: 'md',
    lineHeight: 'base'
  },
  sm: {
    fontSize: 'sm',
    lineHeight: 'short'
  },
  xs: {
    fontSize: 'xs',
    lineHeight: 'normal'
  }
};
export var textStyles = {
  'heading-xl': _objectSpread(_objectSpread({}, headingSizes['xl']), {}, {
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacings.tight
  }),
  'heading-lg': _objectSpread(_objectSpread({}, headingSizes['lg']), {}, {
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacings.tight
  }),
  'heading-md': _objectSpread(_objectSpread({}, headingSizes['md']), {}, {
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacings.tight
  }),
  'heading-sm': _objectSpread(_objectSpread({}, headingSizes['sm']), {}, {
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacings.tight
  }),
  'lead-lg-bold': _objectSpread(_objectSpread({}, textSizes['lg']), {}, {
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacings.tight
  }),
  'lead-lg': _objectSpread(_objectSpread({}, textSizes['lg']), {}, {
    fontWeight: fontWeights.semibold,
    letterSpacing: letterSpacings.tight
  }),
  'lead-sm': _objectSpread(_objectSpread({}, textSizes['sm']), {}, {
    fontWeight: fontWeights.semibold,
    letterSpacing: letterSpacings.tight
  }),
  'body-lg': _objectSpread(_objectSpread({}, textSizes['lg']), {}, {
    fontWeight: fontWeights.normal,
    letterSpacing: letterSpacings.tight
  }),
  'body-sm': _objectSpread(_objectSpread({}, textSizes['sm']), {}, {
    fontWeight: fontWeights.normal,
    letterSpacing: letterSpacings.tight
  }),
  'body-xs': _objectSpread(_objectSpread({}, textSizes['xs']), {}, {
    fontWeight: fontWeights.semibold,
    letterSpacing: letterSpacings.tight
  })
};
var typography = {
  letterSpacings,
  lineHeights,
  fontWeights,
  fonts,
  fontSizes,
  textStyles
};
export default typography;